import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';
import { Card, Text } from 'react-native-paper';

import { usePostCard } from '@/features/posts/components/feed/PostCardContext';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';

const styles = StyleSheet.create({
  content: { gap: 12 },
  blocked: { fontStyle: 'italic', marginBottom: 16 }
});

export const PostCardBody: FC = () => {
  const { title, isBlocked, text } = usePostCard();
  const { t } = useTranslation(LocalizationNameSpace.POSTS, {
    keyPrefix: 'screens.post-detail'
  });

  return (
    <Card.Content style={styles.content}>
      {title && !isBlocked && (
        <Text variant="titleLarge" numberOfLines={2} ellipsizeMode="tail">
          {title}
        </Text>
      )}
      {isBlocked ? (
        <Text
          variant="bodyLarge"
          numberOfLines={1}
          ellipsizeMode="tail"
          style={styles.blocked}
        >
          {t('personBlocked')}
        </Text>
      ) : (
        <Text
          variant="bodyLarge"
          numberOfLines={title ? 2 : 5}
          ellipsizeMode="tail"
        >
          {text}
        </Text>
      )}
    </Card.Content>
  );
};
PostCardBody.displayName = 'PostCardBody';
